import type React from 'react';

export interface SessionPreviewProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
  lines?: 1 | 2 | 3;
  size?: 'xs' | 'sm' | 'md';
}

const sizeClasses = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base'
};

const lineClasses = {
  1: '',
  2: 'line-clamp-2',
  3: 'line-clamp-3'
};

export default function SessionPreview({
  children,
  lines = 2,
  size = 'xs',
  className = '',
  ...props
}: SessionPreviewProps) {
  return (
    <p
      className={`text-text-muted mt-1 ${sizeClasses[size]} ${lineClasses[lines]} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
}